module.exports = __webpack_public_path__ + "02_long_yellow.eaf9162d.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/mama/layer5/02_long_yellow.png
// module id = kOiv
// module chunks = 0